import axios from "@/api/axiosAuthRequired.js"

const instaproBaseUrl = `${process.env.INSTAPRO_API_URL}api/v1/`

export const getSubscriptionPriceTiers = async instaproAccessToken => {
  try {
    const url = `${instaproBaseUrl}coach/coach-subs/price-tiers`
    const config = {
      headers: {
        Authorization: "Bearer " + instaproAccessToken,
      },
    }
    const res = await axios.get(url, config)
    return res.data
  } catch (error) {
    console.error(error)
    return error.response
  }
}

export const getSubscriptionPackages = async (
  coachGameId,
  instaproAccessToken
) => {
  try {
    const url = `${instaproBaseUrl}coach/games/${coachGameId}/coach-subs/packages`
    const config = {
      headers: {
        Authorization: "Bearer " + instaproAccessToken,
      },
    }
    const res = await axios.get(url, config)
    return res.data
  } catch (error) {
    console.error(error)
    return error.response
  }
}

export const setSubscriptionPackages = async (
  coachGameId,
  body,
  instaproAccessToken
) => {
  try {
    const url = `${instaproBaseUrl}coach/games/${coachGameId}/coach-subs/packages`
    const config = {
      headers: {
        "Authorization": "Bearer " + instaproAccessToken,
        "Content-Type": "application/json",
      },
    }
    const res = await axios.post(url, body, config)
    return res.data
  } catch (error) {
    console.error(error)
    return error.response
  }
}

export const getSubscriptionsForCoachGame = async instaproAccessToken => {
  try {
    const url = `${instaproBaseUrl}coach/games/coach-subs`
    const config = {
      headers: {
        Authorization: "Bearer " + instaproAccessToken,
      },
    }
    const res = await axios.get(url, config)
    return res.data
  } catch (error) {
    console.error(error)
    return error.response
  }
}



// WEBPACK FOOTER //
// ./src/api/coachSubscription.js